/**
 * Textos (`es`) de las vistas de Existencias por LUGARES y por ARTÍCULO y del movimiento múltiple (OBR-145). Namespace
 * `backoffice.stockViews`. Mismas claves que `views.ca.ts` (`views.test.ts` e i18n.test.ts); ningún texto literal en las vistas.
 */

export const viewsEs = {
  'backoffice.stockViews': {
    modeLabel: 'Vista de existencias',
    modePlaces: 'Por lugares',
    modeArticles: 'Por artículo',

    treeLabel: 'Lugares del obrador',
    treeHint: 'Elige un lugar para ver qué hay. Solo se lee el lugar elegido.',
    treeExpand: 'Despliega {{place}}',
    treeCollapse: 'Pliega {{place}}',
    treeNoStock: 'Sin existencias',
    treeInactive: 'De baja',
    treeNoPlaceHint: 'Lo que se recibió antes de que existiera la estructura del obrador.',
    treeEmptyStructure:
      'El obrador todavía no tiene ninguna zona definida. Puedes ver lo que no tiene lugar en «Sin lugar» y definir la estructura en Configuración.',
    structureLoadError:
      'No se ha podido leer la estructura del obrador (zonas, secciones y ubicaciones): no se puede decir que no haya. Vuelve a probar.',
    leadDaysUnknown:
      'No se han podido leer los días de aviso de caducidad del obrador: no se puede decir qué lotes caducan pronto, y los que aún no han caducado se ven sin color.',

    placeLinesCount_one: '{{count}} lote',
    placeLinesCount_other: '{{count}} lotes',
    placeMore: 'Hay más lotes en este lugar: carga más.',
    placeEmpty: 'No hay existencias en este lugar.',
    placeEmptyNone: 'Todo tiene lugar: no hay existencias sin lugar.',
    placeLoadError: 'No se han podido cargar las existencias de este lugar. Vuelve a probar.',
    placeLoadMoreError: 'No se han podido cargar más lotes. Vuelve a probar.',
    placeRetry: 'Vuelve a probar',
    loadMore: 'Carga más',
    loadingMore: 'Cargando…',
    groupLabel: 'Lugar: {{place}}',

    cardNoLot: 'Sin lote',
    cardSupplierLot: 'Lote del proveedor: {{code}}',
    cardExpiry: 'Caducidad',
    cardPlace: 'Lugar',
    selectLine: 'Selecciona el lote {{lot}} para moverlo',
    selectNoStock: 'No hay existencias en este lugar: no hay nada que mover.',
    selectUntracked: 'Este artículo no tiene control de existencias: no hay nada que mover.',
    selectArticleGone: 'Este artículo está dado de baja: no se puede mover.',

    expiryNone: 'Sin caducidad',
    expiryToday: 'Caduca hoy',
    expiryTomorrow: 'Caduca mañana',
    expiryIn: 'Caduca dentro de {{count}} días',
    expiryYesterday: 'Caducó ayer',
    expiryAgo: 'Caducó hace {{count}} días',

    timelineTitle: 'Caducidades',
    timelineAria: 'Línea de tiempo de las caducidades de los lotes con existencias',
    timelineToday: 'Hoy',
    timelineSoon: 'Caduca pronto',
    timelineDayUnit: 'd',
    timelineLegendExpired: 'Caducado',
    timelineLegendSoon: 'Caduca pronto',
    timelineLegendOk: 'Con tiempo',
    timelineUndated: 'Sin caducidad: {{lots}}',
    timelineEmpty: 'Ningún lote con existencias y caducidad que dibujar.',
    timelineBar: '{{lot}}: {{when}}',

    selectionCount_one: '{{count}} lote seleccionado',
    selectionCount_other: '{{count}} lotes seleccionados',
    selectionMove: 'Mueve la selección',
    selectionClear: 'Borra la selección',
    selectionDropped:
      'Se han quitado de la selección {{count}} lotes que ya no se pueden mover (han cambiado o ya no tienen existencias).',
    moveDone_one: 'Se ha movido {{count}} lote a {{place}}.',
    moveDone_other: 'Se han movido {{count}} lotes a {{place}}.',
    moveDoneDismiss: 'Cierra el aviso',

    batchTitle: 'Mueve la selección',
    batchBody:
      'Todos los lotes van al mismo lugar. La cantidad de cada lote empieza por todo lo que hay en el origen; puedes bajarla para mover solo una parte. Si un lote falla, no se mueve ninguno.',
    batchDestination: 'Lugar de destino',
    batchDestinationPlaceholder: 'Elige adónde van',
    batchNote: 'Nota',
    batchNotePlaceholder: 'Opcional: por qué se mueven',
    batchColLot: 'Lote',
    batchColFrom: 'Origen',
    batchColQuantity: 'Cantidad a mover',
    batchColRemaining: 'Quedará en el origen',
    batchAvailable: 'Hay {{quantity}} {{unit}}',
    batchAtDestination: 'Ya está en el destino: no se moverá.',
    batchQuantityInvalid: 'Escribe una cantidad mayor que cero.',
    batchQuantityExceeds: 'No puede pasar de las {{quantity}} {{unit}} que hay en el origen.',
    batchNotSelectable: 'Este lote ya no se puede mover.',
    batchSummary_one: 'Se moverá {{count}} lote a {{place}}.',
    batchSummary_other: 'Se moverán {{count}} lotes a {{place}}.',
    batchSkipped_one: '{{count}} lote ya está en el destino y no se moverá.',
    batchSkipped_other: '{{count}} lotes ya están en el destino y no se moverán.',
    batchTooMany: 'Un movimiento admite como máximo {{max}} lotes. Quita alguno de la selección.',
    batchWarning:
      'Hay lotes bloqueados o caducados en la selección. Se pueden mover, pero no se pueden consumir ni expedir. Los bloqueados a mano llegan bloqueados al destino: la cuarentena sigue a la mercancía.',
    batchNoDestinations: 'No hay ningún lugar de destino que admita existencias. Define uno en Configuración.',
    batchConfirm: 'Mueve',
    batchFailed: 'No se ha movido nada. {{reason}}',
    batchFailedItem: 'No se ha movido nada. El lote {{lot}} ({{article}}): {{reason}}',
    batchFailedHint: 'Puedes corregirlo y volver a pulsar «Mueve».',

    err_move_stock_batch_empty: 'No hay ningún lote que mover.',
    err_move_stock_batch_too_large: 'Hay demasiados lotes en un solo movimiento (máximo 200).',
    err_move_stock_batch_client_uuid_conflict:
      'Esta operación ya corresponde a otro movimiento. Vuelve a abrir el diálogo y pruébalo de nuevo.',
    err_move_stock_forbidden: 'No tienes permiso para mover existencias.',
    err_move_stock_no_tenant: 'No se ha podido identificar el obrador. Vuelve a entrar.',
    err_move_stock_batch_bad_item: 'Los datos de este lote no son válidos.',
    err_move_stock_batch_duplicate: 'Este lote sale dos veces del mismo lugar.',
    err_move_stock_batch_chained: 'El destino de un lote es el origen de otro del mismo lote.',
    err_move_stock_insufficient:
      'En el origen ya no hay existencias suficientes: han cambiado desde que elegiste el lote. Vuelve a mirarlo.',
    err_move_stock_same_place: 'Este lote ya está en el lugar de destino.',
    err_move_stock_no_destination: 'Elige un lugar de destino.',
    err_move_stock_bad_destination: 'El lugar de destino ya no existe o no es de este obrador.',
    err_move_stock_destination_without_stock: 'El lugar de destino no admite existencias.',
    err_move_stock_two_lots: 'Un movimiento pertenece a un solo lote.',
    err_move_stock_unknown_article: 'Este artículo ya no existe en este obrador.',
    err_move_stock_unknown_lot: 'Este lote ya no existe o no es de este artículo.',
    err_move_stock_bad_quantity: 'La cantidad no es válida.',
    err_unknown: 'No se ha podido hacer el movimiento.',
  },
} as const;
